import React from 'react';
import PropTypes from 'prop-types';

import { COLUMN_TAG_INVARIANTS } from 'bloko/common/constants/invariants';
import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/column/column.less';

export default function ColumnsRow({ Element, children, ...columnRowProps }) {
    return (
        <Element className="bloko-columns-row" {...columnRowProps}>
            {children}
        </Element>
    );
}

ColumnsRow.propTypes = {
    /** Содержимое внутри строки*/
    children: PropTypes.node,
    /** Кастомный компонент функция или [доступные теги](#invariants)*/
    Element: componentInvariants(COLUMN_TAG_INVARIANTS),
};

ColumnsRow.defaultProps = {
    Element: 'div',
};
